import { Typography, type TypographyProps } from '@musinsa/mds';
import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import type { FC } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';

const LinkTypography: FC<TypographyProps> = ({ children, ...props }) => {
  return (
    <Typography
      variant="body13pxReg"
      textDecoration="underline"
      colorScheme="gray-600"
      className="cursor-pointer"
      {...props}
    >
      {children}
    </Typography>
  );
};

const MusinsaWebPrivacyPolicy = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const cloneSearchParams = new URLSearchParams(searchParams);
  cloneSearchParams.set('modal', 'privacy-policy');

  const href = `${pathname}?${cloneSearchParams.toString()}`;

  return (
    <LinkTypography asChild>
      <Link href={href} shallow>
        자세히
      </Link>
    </LinkTypography>
  );
};

export const PrivacyPolicy = () => {
  const { isMobile, service } = useDeviceInfo();

  if (isMobile || service === SERVICE['29CM']) {
    return (
      <PrivacyPolicyModal>
        <LinkTypography>자세히</LinkTypography>
      </PrivacyPolicyModal>
    );
  }

  return <MusinsaWebPrivacyPolicy />;
};
